import { useState, useEffect } from 'react';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Sidenavbar from '../../Components/Sidenavbar/Sidenavbar';
import UserMenu from '../../Components/UserMenu/UserMenu';
import { fetchData, postData } from '../../Services/apiService';
import { useNavigate } from 'react-router-dom';


function CreateUser(props) {
  const userType = 'admin';
  const navigate = useNavigate();


  const [units, setUnits] = useState([]);
  const [roles, setRoles] = useState([]);
  const [unitsCPOptions, setUnitsCPOptions] = useState([]);
  const [isAdmin, setIsAdmin] = useState(1); // 1 = no admin, 2 = admin
  const [nameToIds, setNameToIds] = useState({});

  const handleGoBack = () => {
    navigate(-1);
  };
  const addUnit = () => {
    setUnits([...units, { id: Date.now(), unitName: '', unitRole: '', maxAmount: '' }]);
  };

  const removeUnit = (id) => {
    setUnits(units.filter((unit) => unit.id !== id));
  };

  const handleInputChange = (id, field, value) => {
  setUnits((prev) => {
    const next = prev.map((u) => (u.id === id ? { ...u, [field]: value } : u));

    const edited = next.find((u) => u.id === id);
    const name = edited.unitName?.toLowerCase() || "";
    const role = edited.unitRole?.toLowerCase() || "";

    if ((field === "unitName" || field === "unitRole") && name && role) {
      const key = `${name}__${role}`;
      const count = next.filter(
        (u) =>
          (u.unitName?.toLowerCase() || "") + "__" + (u.unitRole?.toLowerCase() || "") === key
      ).length;

      if (count > 1) {
        toast.warn("Esa Unidad CP + Rol ya existe.", {
          position: "top-center",
          autoClose: true,
          hideProgressBar: true,
          theme: "dark",
        });
        return prev;
      }
    }

    return next;
  });
};

  useEffect(() => {
    fetcRolesData();
    fetcUnitsCPData();
  }, []);
  const fetcRolesData = async () => {
    try {
      const data = await fetchData('AppUser/GetAppUserRoles');
      setRoles(data.data); 
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetcUnitsCPData = async () => {
  try {
    const data = await postData('BusinessUnit/GetBusinessUnit', {});

    
    const mapNameToIds = {};
    for (const unit of data.data) {
      const name = unit.nameBusinessUnit;
      const id = unit.idBusinessUnit;
      if (!mapNameToIds[name]) mapNameToIds[name] = [];
      mapNameToIds[name].push(id);
    }

    
    const uniqueNameOptions = Object.keys(mapNameToIds)
      .sort((a, b) => a.localeCompare(b))
      .map((name) => ({ value: name, label: name }));

    setNameToIds(mapNameToIds);
    setUnitsCPOptions(uniqueNameOptions);
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

  const addUser = async () => {
    try {
      const userName = document.getElementById('userName').value;
      const userMail = document.getElementById('userMail').value;
      const userPass = document.getElementById('userPass').value;

      if (!userName || !userMail || !userPass) {
        toast.error('Todos los campos son obligatorios', { position: "top-center", autoClose: true, hideProgressBar: true, theme: "dark" });
        return;
      }

     
      const expanded = units.flatMap((unit) => {
        const ids = nameToIds[unit.unitName] || [];
        const isEjecutor = unit.unitRole === 'ejecutor';

        return ids.map((id) => ({
          id, 
          topAmount: isEjecutor ? 0 : Number(unit.maxAmount || 0),
          appUserRoles: [{ id: isEjecutor ? 2 : 1 }], 
        }));
      });

      const seen = new Set();
      const businessUnitAppUsers = expanded.filter((item) => {
        const key = `${item.id}|${item.topAmount}|${item.appUserRoles[0].id}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      const payload = {
        name: userName,
        email: userMail,
        password: userPass,
        isAdmin,
        businessUnitAppUsers,
      };

      const response = await postData('AppUser', payload);
      if (response.succes) {
        toast.success('Usuario agregado correctamente', { position: "top-center", autoClose: true, hideProgressBar: true, theme: "dark" });
        window.location.href = '/AdminUsers';
      } else {
        toast.error('Error al agregar el usuario', { position: "top-center", autoClose: true, hideProgressBar: true, theme: "dark" });
      }
    } catch (error) {
      console.error('Error al agregar usuario:', error);
      toast.error('Ocurrió un error inesperado', { position: "top-center", autoClose: true, hideProgressBar: true, theme: "dark" });
    }
  };
  const handleSelectAll = (e) => {
    e.target.select();
  };


  return (
    <div className="container-fluid px-0 m-0 d-flex flex-column flex-md-row">
      <Sidenavbar userType={userType} />
      <div className="container-fluid px-16">
      <UserMenu userType="admin" />
      <ToastContainer />
        {/* Register Users */}
        <div className="row mt-40">
          <div className="col-12 col-md-6 col-lg-3">
            <a href="#">
              <button className="btn -text" onClick={handleGoBack}>
                <i className="fa-solid fa-arrow-left"></i> Regresar
              </button>
            </a>
          </div>
        </div>
        <div className="row centered">
          <div className="col-12 col-md-8">
            <div className="card -walnut">
              <div className="row">
                <div className="col">
                  <p className="h2">
                    Agregar usuario
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-4 mt-3 align-content-top">
                  <label htmlFor="userName" className="form-label">Usuario</label>
                  <input type="text" className="form-control -input" id="userName" placeholder="Ej. Juan Flores" />
                </div>
                <div className="col-12 col-md-4 mt-3 align-content-top">
                  <label htmlFor="userMail" className="form-label">Correo</label>
                  <input type="email" className="form-control -input" id="userMail" placeholder="Ej.  jflores@correo.com" />
                </div>
                <div className="col-12 col-md-4 mt-3 align-content-top">
                  <label htmlFor="userPass" className="form-label">Contraseña</label>
                  <input type="password" className="form-control -input" id="userPass"  />
                </div>

                {/* Checkbox isAdmin (misma lógica que EditUser: 2 = admin, 1 = no) */}
                <div className="col-12 col-md-4 mt-3">
                  <label className="form-label">¿Es administrador?</label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="isAdminCheckboxCreate"
                      checked={isAdmin === 2}
                      onChange={(e) => setIsAdmin(e.target.checked ? 2 : 1)}
                    />
                    <label className="form-check-label" htmlFor="isAdminCheckboxCreate">
                      Activar la administración de documentos
                    </label>
                  </div>
                </div>

                <hr />
                <div className="row">
                  <div className="col">
                    <p className="h3">
                      Asignar unidades de negocio
                    </p>
                  </div>
                </div>
                <div className="row">
                {units.map((unit) => (
                  <div key={unit.id} className="col-12 col-md-4 align-content-top mt-3">
                    <div className='card'>
                      <div className='row'>
                        <div className="col-6 col-md-12 mt-3 align-content-top">
                          <label htmlFor={`unitName-${unit.id}`} className="form-label">Unidad CP</label>
                          <Select
                            id={`unitName-${unit.id}`}
                            options={unitsCPOptions}
                            value={
                              unit.unitName
                                ? { value: unit.unitName, label: unit.unitName }
                                : null
                            }
                            onChange={(opt) => handleInputChange(unit.id, 'unitName', opt?.value || '')}
                            placeholder="Selecciona una unidad"
                          />
                        </div>

                        <div className="col-6 col-md-12 mt-3">
                          <div className="d-flex">
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name={`unitRole-${unit.id}`}
                                id={`aprovador-${unit.id}`}
                                value="aprovador"
                                checked={unit.unitRole === 'aprovador'}
                                onChange={(e) =>
                                  handleInputChange(unit.id, 'unitRole', e.target.value)
                                }
                              />
                              <label className="form-check-label" htmlFor={`aprovador-${unit.id}`}>
                                Aprobador
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name={`unitRole-${unit.id}`}
                                id={`ejecutor-${unit.id}`}
                                value="ejecutor"
                                checked={unit.unitRole === 'ejecutor'}
                                onChange={(e) =>
                                  handleInputChange(unit.id, 'unitRole', e.target.value)
                                }
                              />
                              <label className="form-check-label" htmlFor={`ejecutor-${unit.id}`}>
                                Ejecutor
                              </label>
                            </div>
                            
                          </div>
                        </div>
                        <div className="col-6 col-md-6 mt-3 align-content-top">
                          <label htmlFor={`maxAmount-${unit.id}`} className="form-label">Monto Máximo</label>
                          <input
                            type="number"
                            className="form-control -input"
                            id={`maxAmount-${unit.id}`}
                            value={unit.maxAmount}
                            onChange={(e) =>
                              handleInputChange(unit.id, 'maxAmount', e.target.value)
                            }
                            disabled={unit.unitRole === 'ejecutor'} 
                            onFocus={handleSelectAll}
                            onClick={handleSelectAll}

                          />
                        </div>
                        <div className="col-12 mt-3 text-end">
                            <button
                              className="btn btn-danger"
                              onClick={() => removeUnit(unit.id)}
                            >
                              Eliminar
                            </button>
                          </div>
                      </div>
                    </div>
                  </div>
                  ))}
                </div>
                <div className="row mt-40 justify-content-center">
                  <div className="col-12 col-md-6">
                    <button 
                      className="btn -secondary"
                      onClick={addUnit}
                    >
                      Agregar Unidad CP
                    </button>
                  </div>
                </div>
              
               
              </div>
              <hr/>
              <div className="row mt-40 justify-content-center">
                <div className="col-12 col-md-6">
                  <a href="/AdminUsers">
                    <button className="btn -secondary">
                      Cancelar
                    </button>
                  </a>
                </div>
                <div className="col-12 col-md-6">
                  <button 
                    className="btn -primary"
                    onClick={addUser}
                  >
                    Agregar usuario
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Register Users */}
      </div>
    </div>
  );
}

export default CreateUser;
